import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'mainChecker']

  initialize() {
    if (this.allChecked()) {
      this.mainCheckerTarget.checked = true
    }
  }

  checkAll(event) {
    if (this.allChecked() && !event.target.checked) {
      this.checkboxTargets.forEach(checkbox => (checkbox.checked = false))
    } else if (!event.target.checked) {
      this.checkboxTargets.forEach(checkbox => (checkbox.checked = false))
    } else {
      this.checkboxTargets.forEach(checkbox => (checkbox.checked = true))
    }
    const submitBtn = document.querySelector('#submit-membership')
    if (submitBtn) {
      submitBtn.click()
    }
  }

  allChecked() {
    return this.checkboxTargets.every(checkbox => checkbox.checked)
  }

  someChecked() {
    return this.checkboxTargets.some(checkbox => checkbox.checked)
  }
}
